import qs from "qs";
import React from "react";
import { type Font, type Theme } from "./models";

export const getEmbedUrl = (clientFriendlyId: string, displayPagination: boolean, displayHeader: boolean, locale: string, font: Font, perPage: string, artistIds: number[], productionIds: number[], theme: Theme, pastShowDays: number, upcomingShowDays: number, includeCancelled: boolean): string => {
  const queryParamsObj = {
    theme,
    font,
    artistIds,
    productionIds,
    lang: locale,
    per_page: perPage,
    upcoming_limit: upcomingShowDays,
    cancelled: includeCancelled,
    ...(!displayHeader && { header: false }),
    ...(displayPagination && { page: 1 }),
    ...(pastShowDays && { past_limit: pastShowDays })
  };

  const queryString = qs.stringify(queryParamsObj, { arrayFormat: "comma" });

  return `${site.deploymentValues.forClientsBaseUrl}/embed/v1/shows/${clientFriendlyId}?${queryString}`;
};

export const getRawJsonUrl = (clientFriendlyId: string, locale: string, perPage: string, artistIds: number[], productionIds: number[], pastShowDays: number, upcomingShowDays: number, includeCancelled: boolean): string => {
  const queryParamsObj = {
    artistIds,
    productionIds,
    lang: locale,
    per_page: perPage,
    upcoming_limit: upcomingShowDays,
    cancelled: includeCancelled,
    ...(pastShowDays && { past_limit: pastShowDays }),

    page: 1
  };

  const queryString = qs.stringify(queryParamsObj, { arrayFormat: "comma" });

  return `${site.deploymentValues.forClientsBaseUrl}/api/v1/shows/${clientFriendlyId}?${queryString}`;
};

export const getEmbedCode = ({ url, height, width }: { url: string, height: string, width: string }) => <embed src={url} style={{ height, width }} />;

export const getEmbedCodeText = ({ url, height, width }: { url: string, height: string, width: string }) => "<embed src=\"" + url + "\" width=\"" + width + "\" height=\"" + height + "\" frameborder=\"0\" />";
